<!-- eslint-disable vue/no-v-html -->
<template>
  <CollapsableSection
    data-test="description"
    :title="t('product_description')"
    section-classes="w-full text-sm text-gray-800 border-b border-gray-200 border-solid last:border-0"
    title-classes="lg:text-xl"
    :is-open="isOpen"
    collapsable-padding="px-8 xl:px-12 py-4"
    collapsable-content-classes="px-8 xl:px-12 py-6"
    @update:open="(value) => emit('update:open', value)"
  >
    <div class="flex flex-col w-full xl:flex-row xl:gap-x-16">
      <div class="w-full max-w-[562px]">
        <div class="mb-3 lg:mb-4" data-test="description-content-variant" v-html="text" />

        <CHeading v-if="technicalDescription" :level="5">{{ t('technical_description') }}</CHeading>

        <div
          v-if="technicalDescription"
          class="mb-3 lg:mb-4"
          data-test="technical-description-content-variant"
          v-html="technicalDescription"
        />

        <table class="w-full mt-4">
          <tbody>
            <tr
              v-for="attribute in description"
              :key="attribute.attributeName"
              class="flex justify-between pt-1 pr-0 border-b border-gray-300 border-solid first:pt-0 last:border-b-0 last:pb-0"
            >
              <td>{{ attribute.attributeLabel || attribute.attributeName }}:</td>
              <td class="flex font-bold">{{ getAttributeValue(attribute) }}</td>
            </tr>
            <tr
              v-if="isEANVisible"
              class="flex justify-between pt-1 pr-0 border-b border-gray-300 border-solid first:pt-0 last:border-b-0 last:pb-0"
            >
              <td>{{ t('EAN_art_nr') }}</td>
              <td class="flex font-bold">{{ ean }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </CollapsableSection>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ProductAttribute } from '@/types/products';

type Props = {
  isOpen?: boolean;
  text?: string;
  technicalDescription?: string;
  description?: ProductAttribute[];
  ean?: string;
};

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
  text: '',
  technicalDescription: '',
  description: () => [],
  ean: '',
});

const emit = defineEmits<{
  (e: 'update:open', v: boolean): void;
}>();

const { t } = useI18n();
const { getAttributeValue } = useProductAttributes();

const isEANVisible = computed(() => !!props.ean);
</script>

<script lang="ts">
export default defineComponent({
  name: 'ProductDetailPageDescriptionSection',
});
</script>
